const BellIcon = ({ size = 24 }: { size?: number }) => {
  return (
    <svg width={size} height={size} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <circle cx="12" cy="12" r="12" fill="white" />
      <path
        d="M10.5596 14.9314C10.5596 15.7267 11.2043 16.3714 11.9996 16.3714C12.7949 16.3714 13.4396 15.7267 13.4396 14.9314"
        stroke="#848F9A"
        strokeWidth="0.9"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M16.3187 14.6228H7.67969L7.6851 14.6095C7.71804 14.5516 7.88887 14.3056 8.19759 13.8716L8.52172 13.4175V10.5514C8.52172 8.61403 10.0071 7.03495 11.8658 6.96255L11.9992 6.95996C13.9198 6.95996 15.4767 8.5679 15.4767 10.5514V13.4175L16.2141 14.4592C16.2889 14.5683 16.3238 14.6228 16.3187 14.6228Z"
        stroke="#848F9A"
        strokeWidth="0.9"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M11.9994 16.8214C10.9556 16.8214 10.1094 15.9752 10.1094 14.9314H11.0094C11.0094 15.4782 11.4526 15.9214 11.9994 15.9214C12.5461 15.9214 12.9894 15.4782 12.9894 14.9314H13.8894C13.8894 15.9752 13.0432 16.8214 11.9994 16.8214Z"
        fill="#848F9A"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M11.9903 6.51009L11.999 6.51001C14.1817 6.51001 15.9265 8.33321 15.9265 10.5514V13.2744L16.585 14.2046C16.6229 14.2599 16.6538 14.3058 16.6753 14.3395C16.685 14.3547 16.6983 14.3758 16.7099 14.3971L16.7102 14.3977C16.7141 14.4049 16.7294 14.4328 16.7422 14.4685C16.7423 14.4688 16.7424 14.4692 16.7426 14.4696C16.7468 14.4811 16.7703 14.5455 16.7689 14.6296C16.7682 14.6736 16.7603 14.7864 16.6761 14.8963C16.5743 15.0294 16.4288 15.0729 16.3185 15.0729H7.67949C7.52982 15.0729 7.38993 14.9984 7.3063 14.8743C7.22266 14.7502 7.20622 14.5926 7.26244 14.4539L7.26785 14.4405C7.27531 14.4221 7.28399 14.4042 7.29382 14.3869C7.34136 14.3034 7.53216 14.0305 7.83069 13.6108L8.07153 13.2735V10.5514C8.07153 8.38442 9.73596 6.59521 11.8481 6.51294L11.8569 6.51269L11.9903 6.51009ZM12.0032 7.41001L11.8789 7.41243C10.2755 7.47719 8.97153 8.84523 8.97153 10.5514V13.4176C8.97153 13.5113 8.94225 13.6028 8.88778 13.6791L8.56409 14.1325C8.56404 14.1326 8.56415 14.1324 8.56409 14.1325C8.55444 14.1461 8.54476 14.1597 8.53538 14.1729H15.4598L15.1092 13.6776C15.0554 13.6016 15.0265 13.5107 15.0265 13.4176V10.5514C15.0265 8.80417 13.6598 7.41237 12.0032 7.41001Z"
        fill="#848F9A"
      />
    </svg>
  );
};

export default BellIcon;
